import React from "react";

function ArrowDownSvg({ color, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="8"
      fill="none"
      viewBox="0 0 14 8"
      className={className}
    >
      <path
        stroke={color || "#002247"}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M1 1l6 6 6-6"
      ></path>
    </svg>
  );
}

export default ArrowDownSvg;
